import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../shared/schemas.js';

export const actionCategoryLabelSchema = z
  .string()
  .trim()
  .min(1, 'Le libellé est obligatoire.')
  .max(60, 'Le libellé ne peut pas dépasser 60 caractères.');

export const actionCategoryPositionSchema = z.number().int().min(0);

export const actionCategorySchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  position: z.number().int(),
  /** Actions du catalogue rangées dans cette catégorie, archivées comprises. */
  actionCount: z.number().int().nonnegative(),
  createdAt: isoUtcDateTimeSchema,
  updatedAt: isoUtcDateTimeSchema,
});

export type ActionCategory = z.infer<typeof actionCategorySchema>;

export const createActionCategorySchema = z
  .object({
    label: actionCategoryLabelSchema,
    /** Par défaut, la catégorie se place après les autres. */
    position: actionCategoryPositionSchema.optional(),
  })
  .strict();

export type CreateActionCategoryInput = z.infer<typeof createActionCategorySchema>;

export const updateActionCategorySchema = z
  .object({
    label: actionCategoryLabelSchema.optional(),
    position: actionCategoryPositionSchema.optional(),
  })
  .strict()
  .refine((input) => input.label !== undefined || input.position !== undefined, {
    message: 'Indiquez au moins un champ à modifier.',
  });

export type UpdateActionCategoryInput = z.infer<typeof updateActionCategorySchema>;

export const actionCategoryListSchema = z.object({
  categories: z.array(actionCategorySchema),
});

export type ActionCategoryList = z.infer<typeof actionCategoryListSchema>;
